const PricingPeriodsSelectors = {
  sitePricingPlans: (state) => state.pricingPeriodsReducer.sitePricingPlans,
  pricingPeriods: (state) => state.pricingPeriodsReducer.pricingPeriods,
  loading: (state) => state.pricingPeriodsReducer.loading,
};

export default PricingPeriodsSelectors;
